/**
 * AOV Bundle Cart Drawer Fix
 * 
 * Problem: The AOV Bundle Upsell app detects the theme name as "PagePilot AI Store"
 * (from window.Shopify.theme.schema_name), which is not in AOV's known theme list.
 * When AOV's isThemeReloadAble() returns true for unknown themes, its
 * refreshCartForTheme() falls back to window.location.reload() -- causing the
 * full page reload after Add to Cart.
 *
 * Fix: Override window.aovUtils.refreshCartForTheme and getAllSectionsByTheme
 * so AOV uses the theme's native cart-drawer custom element (renderContents)
 * instead of reloading the page.
 *
 * This script must run AFTER aov-util.min.js loads, so it uses a MutationObserver
 * to wait for window.aovUtils to be defined before patching it.
 */
(function () {
  'use strict';

  var CART_SECTIONS = 'cart-drawer,cart-icon-bubble';

  function patchAovUtils() {
    if (!window.aovUtils) return false;

    // Override refreshCartForTheme to use the native cart-drawer renderContents
    window.aovUtils.refreshCartForTheme = function (themeName, sections, isCartView) {
      var cartDrawer = document.querySelector('cart-drawer');

      // If the cart-drawer custom element has renderContents, use it
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        var sectionsToFetch = CART_SECTIONS;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + '?sections=' + sectionsToFetch)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            cartDrawer.classList.remove('is-empty');
            var inner = cartDrawer.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            cartDrawer.renderContents({ sections: data });
            // Open the drawer after updating
            setTimeout(function () {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                cartDrawer.classList.add('animate', 'active');
                document.body.classList.add('overflow-hidden');
              }
            }, 50);
          })
          .catch(function (err) {
            console.warn('[AOV Cart Fix] fetch failed, falling back to open:', err);
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          });
        return;
      }

      // Fallback: just open the drawer if it exists
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }

      // Last resort: reload (original behavior) -- should never reach here
      window.location.reload();
    };

    // Override getAllSectionsByTheme so AOV requests the right sections
    window.aovUtils.getAllSectionsByTheme = function (themeName) {
      return CART_SECTIONS;
    };

    // Override isThemeReloadAble so AOV doesn't treat this theme as reload-able
    window.aovUtils.isThemeReloadAble = function (themeName) {
      return false;
    };

    console.log('[AOV Cart Fix] aovUtils patched successfully.');
    return true;
  }

  // Try immediately in case aovUtils is already loaded
  if (!patchAovUtils()) {
    // Poll until aovUtils is available (it loads async via script injection)
    var attempts = 0;
    var maxAttempts = 100; // 10 seconds max
    var interval = setInterval(function () {
      attempts++;
      if (patchAovUtils() || attempts >= maxAttempts) {
        clearInterval(interval);
        if (attempts >= maxAttempts) {
          console.warn('[AOV Cart Fix] aovUtils never loaded, patch not applied.');
        }
      }
    }, 100);
  }
})();
